import React, { useCallback } from 'react';

import { dispatchMessage, MessagingEvents } from '@services/messagingService';

import { createEcommerceProduct, createModifyCartEvent, useTrackModifyCartEvent } from '../../../ecommerce';
import { useDeleteProductAwaitable, useDeleteUpsellingAwaitable } from '../../../services';
import { CartActions, ECartActions, IRemoveAllItemEntriesFromCartAction } from '../model';

export const useRemoveAllEntries = (dispatch: React.Dispatch<CartActions>) => {
  const { request: deleteItemRequest } = useDeleteProductAwaitable();
  const { request: deleteUpsellingRequest } = useDeleteUpsellingAwaitable();
  const trackModifyCartEvent = useTrackModifyCartEvent();

  return useCallback(
    async (data: IRemoveAllItemEntriesFromCartAction) => {
      const {
        product: { itemId, upselling },
        product,
      } = data;

      const deleteProductsResponse = upselling
        ? (await deleteUpsellingRequest({ itemId }))?.data
        : (await deleteItemRequest({ itemId }))?.data;

      dispatchMessage({ event: MessagingEvents.ECartManipulationEvents.CART_UPDATE_EVENT });

      if (deleteProductsResponse) {
        dispatch({ actionType: ECartActions.UPDATE_PRODUCTS, payload: deleteProductsResponse });
        trackModifyCartEvent({
          ...createModifyCartEvent(product.count, 0),
          product: createEcommerceProduct(product),
        });
      }
    },
    [dispatch, trackModifyCartEvent, deleteItemRequest, deleteUpsellingRequest],
  );
};
